const STAGING_CX_TESTER = /cx-staging-.+hbdev.io/;
const STAGING_MX_TESTER = /hb-mx-staging-.+.(web.preview.stg-us-east-1-v7|web.e2e.stg-us-east-1-v7).hbdev.io/;
const STAGING_APP_TESTER = /hb-app-staging-.+.(web.preview.stg-us-east-1-v7|web.e2e.stg-us-east-1-v7).hbdev.io/;
const STAGING_CX_DOMAIN = 'cx-staging';
const STAGING_CX_API_DOMAIN = 'app-staging';
const STAGING_QA_API_BASE_URL = 'https://api.hbqa.dev';
/**
 * Get a specific query parameter from the current URL
 * @param param - The name of the query parameter to retrieve
 * @returns The value of the query parameter, or null if not found
 * @deprecated Please use react-router or QueryParamProvider API instead so we can test it easily in tests.
 */
export function getQueryParam(param) {
    const search = new URLSearchParams(window.location.search);
    return search.get(param);
}
/**
 * Get query parameters from the current URL as a key-value object
 * @returns Object containing all query parameters from window.location.search
 * @deprecated Please use react-router or QueryParamProvider API instead so we can test it easily in tests.
 */
export function getQueryParams() {
    const search = new URLSearchParams(window.location.search);
    return Object.fromEntries(search.entries());
}
/**
 * Extracts the domain/hostname from a URL path
 * Returns undefined if path is invalid or empty
 */
export function extractDomain(path) {
    if (!path) {
        return undefined;
    }
    try {
        const url = new URL(path);
        return url.hostname;
    }
    catch {
        return undefined;
    }
}
export function openLinkInNewTab(url) {
    window.open(url, '_blank', 'noopener');
}
/**
 * Get the staging API base URL based on the current hostname
 * Handles different staging environments (MX, APP, CX, QA)
 */
export function getStagingApiBaseUrl() {
    if (STAGING_MX_TESTER.test(window.location.href)) {
        return ('https://' +
            window.location.hostname
                .replace('hb-mx-staging-', 'hb-app-staging-')
                .replace('.web.', '.api.'));
    }
    if (STAGING_APP_TESTER.test(window.location.href)) {
        return 'https://' + window.location.hostname.replace('.web.', '.api.');
    }
    if (STAGING_CX_TESTER.test(window.location.href)) {
        return getStagingCXApiBaseUrl();
    }
    else {
        return getStagingQAApiBaseUrl();
    }
}
function getStagingCXApiBaseUrl() {
    const cxApiUrl = `${window.location.protocol}//${window.location.host.replace(STAGING_CX_DOMAIN, STAGING_CX_API_DOMAIN)}/`;
    return cxApiUrl.replace('.web.', '.api.');
}
function getStagingQAApiBaseUrl() {
    return STAGING_QA_API_BASE_URL;
}
//# sourceMappingURL=url.utils.js.map